<script>
    // Stores 
    import { 
        textSite,
        linkPesquisaVendas,
        linkPesquisaLocacao,

    } from '../store.js';  

	// Componentes
    import PageHeader                       from './../components/PageHeader.svelte';
    import { Router, Link, link , Route }   from "svelte-routing";
    import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

    // Code
    let titlePage = 'Quem somos';

	let itensIcon = [
		{
			title: 'Vendas',
			icon: '<i class="fas fa-door-open color-primary fa-3x"></i>',
            text: `Intermediar a realização de negócios seguros, vantajosos e que transmitam ao cliente a certeza de poder contar sempre com a empresa.`,
            link: $linkPesquisaVendas
        },   
		{
			title: 'Locação',
			icon: '<i class="fas fa-key color-primary fa-3x"></i>',
            text: `Presteza no atendimento, apuro e técnica no fechamento de contratos.`,
            link: $linkPesquisaLocacao
        },   
		{
			title: 'Condomínios',
			icon: '<i class="fas fa-building color-primary fa-3x"></i>',
            text: `Ampla gama de serviços com o objetivo de amparar os clientes nos mais variados tópicos que um Condomínio pode apresentar. Uma administração realizada com transparência, atenção e sempre voltada ao auxílio na resolução de problemas.`,
            link: '/administracao-condominios'
        },   
    ];

</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container clearfix text-justify">
        <h2 class="title color-primary mb-20">
            Missão
        </h2>
        <p>
            Gerar e manter benefícios concretos. Valorizar e proteger os bens dos clientes, mantendo com estes uma relação baseada em lealdade, transparência, e em um contínuo nível de eficácia.
        </p>
        <h2 class="title color-primary mt-35 mb-20">
            Valores
        </h2>
        <ul>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                Honestidade – alicerce de qualquer negociação;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                Ética – competitividade ferrenha e dedicada ao cliente, mas com noções de classe, cuja adoção é um imperativo da empresa;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                Disciplina – leva ao apuro e mantém o indispensável sentimento de tranquilidade que devemos passar ao nosso cliente;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                Conhecimento – um dos principais fatores que diferencia um profissional de um aventureiro;
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                Competência – resultado somente alcançado com a fusão dos valores acima mencionados.
            </li>
        </ul>
        <h2 class="title color-primary mt-35 mb-20">
            Negócios
        </h2>
        <div class="grid grid-size--1 grid-size-sm--3 grid-gap-30">
            {#each itensIcon as item}
            <a class="card-border card-hover--primary hover-transform" href="{item.link}" title="Ir para {item.title}" >
                {@html item.icon}                
                <h2 class="title mb-20 mt-25">{item.title}</h2>
                <p class="no-breakline--xs mb-0">
                    <small>
                        {item.text}
                    </small>
                </p>
            </a>
            {/each}
        </div>
    </div>
</section>